export const routeConstant = {
  HOME: '/',
  ABOUT: '/about',
  TECHNICAL_SPECIFICATION: '/technicalSpecification',
  INFRASTRUCTURE: '/infrastructure',
  COLLECTION: '/collection',
  PRODUCT_400x400: '/products400x400',
  PRODUCT_500x500: '/products500x500',
  EXPORT: '/export',
  CATALOGUE_400X400: '/catalogue400x400',
  CATALOGUE_500X500: '/catalogue500x500',
  E_CATALOGUE: '/e-catalogue',
  CONTACT: '/contact',
};